import {
  buildFallbackAnalyticsAttributionState,
  readAnalyticsAttributionState,
} from '@/analytics/analytics-attribution-state';

export function buildAnalyticsAttributionProperties(params?: {
  fallbackReferrer?: string | null;
  fallbackSearchParams?: URLSearchParams | null;
}) {
  const storedState = readAnalyticsAttributionState();
  const fallbackState = buildFallbackAnalyticsAttributionState({
    referrer: params?.fallbackReferrer ?? null,
    searchParams: params?.fallbackSearchParams ?? null,
  });
  const state = storedState ?? fallbackState;
  const firstTouch = state?.firstTouch;
  const lastTouch = state?.lastTouch;

  return {
    first_touch_source: firstTouch?.source ?? null,
    first_touch_medium: firstTouch?.medium ?? null,
    first_touch_campaign: firstTouch?.campaign ?? null,
    first_touch_content: firstTouch?.content ?? null,
    first_touch_term: firstTouch?.term ?? null,
    first_touch_landing_page: firstTouch?.landingPage ?? null,
    first_touch_click_id: firstTouch?.clickId ?? null,
    first_touch_referrer: firstTouch?.referrer ?? null,
    first_touch_referrer_host: firstTouch?.referrerHost ?? null,
    last_touch_source: lastTouch?.source ?? null,
    last_touch_medium: lastTouch?.medium ?? null,
    last_touch_campaign: lastTouch?.campaign ?? null,
    last_touch_content: lastTouch?.content ?? null,
    last_touch_term: lastTouch?.term ?? null,
    last_touch_landing_page: lastTouch?.landingPage ?? null,
    last_touch_click_id: lastTouch?.clickId ?? null,
    last_touch_referrer: lastTouch?.referrer ?? null,
    last_touch_referrer_host: lastTouch?.referrerHost ?? null,
  };
}
